import { z } from 'zod';
import { newPartnerFormSchema } from '../model';
import { CreatePartnerProfileDTO } from '../types';

class PartnerMapper {
  public processCreateAccountFormToAPIDTO(formData: z.infer<typeof newPartnerFormSchema>): CreatePartnerProfileDTO {
    return {
      contact: {
        ...formData.contact,
        ...this.when(!!formData.contact.phone, { phone: formData.contact.phone }),
      },
    };
  }

  private when<T extends object>(condition: boolean, value: T): Partial<T> {
    return condition ? value : {};
  }
}

export const partnerMapper = new PartnerMapper();
